export default __webpack_public_path__ + "static/media/explain2_en.ecc257ad.png";